import { lazy } from 'react';

// Components
import withSuspense, { lazyRetry } from '@components/suspense';

const LazyComponent = lazy(() =>
  lazyRetry(
    () => import(/* webpackChunkName: "partnerDiscountPaymentUnavailable" */ './PartnerDiscountPaymentUnavailable'),
  ),
);

const LazyComponentWithSuspense = withSuspense<{}>(LazyComponent, 'PartnerDiscountPaymentUnavailable');

// Exports
export default LazyComponentWithSuspense;
export { LazyComponent as PartnerDiscountPaymentUnavailable };
